@if (!!startAt && !isError) {
<app-waiting
  [startAt]="startAt"
  [theme]="theme"
  [timezone]="timezone"
  [queueName]="queueName"
></app-waiting>
} @if (isDebug) {
<div>state: {{ state() }}</div>
} @if (!startAt && !isLoading) {
<div class="text-center container-pad-md">
  <h1 [innerHTML]="'Oups!' | translate"></h1>
  <h3 [innerHTML]="'Appointment not found...' | translate"></h3>
  <p [innerHTML]="'Most probably the meeting was cancelled and our notification hasn\'t reached you yet. We are sorry for any inconvenience created.' | translate"></p>
</div>
} @if (isError) {
<div class="text-center container-pad-md">
  <h1 [innerHTML]="'Something unexpected happened...' | translate"></h1>
  <h3 [innerHTML]="'We could not communicate with the service. We are sorry for any inconvenience created.' | translate"></h3>
  @if (errorMessage) {
  <p>{{ "Reason" | translate }}: {{ errorMessage }}</p>
  }
  <!-- <av-card type="danger" class="error">
    <av-card-header>{{'Something unexpected happened...' | translate}}</av-card-header>
    <av-card-body>
      <h3 translate>We could not communicate with the service. We are sorry for any inconvenience created.</h3>
      <p *ngIf="errorMessage">{{'Reason'| translate}}: {{errorMessage}}</p>
    </av-card-body>
  </av-card> -->
</div>
}
